'use client';

import * as React from 'react';
import { IconLoading02 } from 'icon/General/loading-02';
import { signIn } from 'next-auth/react';
import { Button, Input, Label } from 'ui';
import { sleep } from 'utils';
import { z } from 'zod';

const schema = z.string().email();

export function LoginForm() {
  const [error, setError] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const handleSubmit = async (email: string) => {
    try {
      schema.parse(email);
      setLoading(true);
      await signUpAffonso(email);

      await signIn('email', {
        email,
      });
    } catch {
      setError(`Invalid email address`);
    } finally {
      setLoading(false);
    }
  };
  return (
    <form
      className="flex flex-col gap-4"
      onSubmit={(e) => {
        e.preventDefault();
        const email = e.target.email.value as string;
        void handleSubmit(email);
      }}
    >
      <div className="grid w-full items-center gap-1.5">
        <Label className="text-gray-700" htmlFor="email">
          Email
        </Label>
        <Input
          destructive={error.length > 0}
          id="email"
          name="email"
          onChange={() => {
            setError('');
          }}
          placeholder="Enter your email"
        />
        {error && <p className="pt-1.5 text-sm text-error-500">{error}</p>}
      </div>
      <Button className="gap-1" disabled={loading} size="lg" type="submit">
        {loading && <IconLoading02 className="animate-spin" />}
        Continue with Email
      </Button>
    </form>
  );
}

async function signUpAffonso(email: string) {
  const referralCookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith('affonso_referral='))
    ?.split('=')[1];

  if (referralCookie) {
    window.Affonso?.signup(email);
    // Add a small delay to ensure the signup API is called
    await sleep(0.5);
  }
}
